import React from 'react';

import { GetArticleDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetArticleDto';
import { Grid } from '../../../common/components/Grid/Grid';
import {
  ArticleModeText,
  CardTypeText,
  LegalBasisTypeText,
} from '../../../common/spdCore/validation/schemas';

interface ArticlesProps {
  data?: GetArticleDto[];
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  enableMultiSelect?: boolean;
  selectedKeys?: string[];
}

export const articleForGrid = (article: GetArticleDto) => {
  return {
    key: article.id,
    values: {
      'article.lp': article.lp,
      'article.description': article.description,
      'article.legalBasis': article.legalBasis,
      'article.legalBasisType':
        LegalBasisTypeText[
          article.legalBasisType as keyof typeof LegalBasisTypeText
        ] || '',
      'article.legalBasisTypeValidFrom': article.legalBasisTypeValidFrom
        ? new Date(article.legalBasisTypeValidFrom).toISOString().split('T')[0]
        : '',
      'article.reason': article.reason,
      'article.mode':
        ArticleModeText[article.mode as keyof typeof ArticleModeText],
      'register.name': article.register?.name,
      'article.cardType':
        CardTypeText[article.cardType as keyof typeof CardTypeText],
      'article.automaticReady': article.automaticReady ? 'TAK' : '',
      'pricingGroup.name': article.pricingGroup?.name || '',
      'article.attention': article.attention,
      'article.autoSupporting': article.autoSupporting ? 'TAK' : '',
    },
    orderByValues: {
      'article.lp': String(article.lp).padStart(10, '0'),
    },
  };
};

export const Article: React.FC<ArticlesProps> = props => {
  const columns = [
    { header: 'Lp', property: 'article.lp' },
    { header: 'Opis', property: 'article.description' },
    { header: 'Podstawa prawna', property: 'article.legalBasis' },
    { header: 'Typ podstawy prawnej', property: 'article.legalBasisType' },
    { header: 'Obowiązuje od', property: 'article.legalBasisTypeValidFrom' },
    { header: 'Powód', property: 'article.reason' },
    { header: 'Obsługuje', property: 'article.mode' },
    { header: 'Rejestr', property: 'register.name' },
    { header: 'Karta', property: 'article.cardType' },
    { header: 'Automatyzacja', property: 'article.automaticReady' },
    { header: 'Bad. pomocnicze', property: 'article.autoSupporting' },
    { header: 'Grupa cenowa', property: 'pricingGroup.name' },
    { header: 'Uwaga', property: 'article.attention' },
  ];

  return (
    <Grid
      data={props.data && props.data.map(d => articleForGrid(d))}
      columns={columns}
      showFilter={true}
      initialOrderColumn="article.lp"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak podstaw prawnych w systemie"
      refresh={props.refresh}
      enableMultiSelect={props.enableMultiSelect}
      selectedKeys={props.selectedKeys}
      showExport={true}
    />
  );
};
